import { Badge } from '../../../ui/badge';

export default function DeactivatedBadge() {
    return (
        <Badge
            variant="outline"
            className="border-rose-500/20 bg-rose-500/10 text-rose-300"
        >
            Deactivated
        </Badge>
    );
}
